export const MY_DRAFT_MERCHANT_APPLICATION = gql`
    query myDraftMerchantApplication {
        myDraftMerchantApplication {
            id
            partnerId
            partnerOfPartnerId
            status
            serviceRequirements
            merchantInformation
            outletInformation
            businessInformation
            supportingDocuments
            merchantAccountNumber
            partner {
                countryDetails {
                    alpha2Code
                }
            }
        }
    }
`;
